/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Browser_Folder_Item_Count_HintInputs */

const en_zotero_browser_folder_item_count_hint = /** @type {(inputs: Zotero_Browser_Folder_Item_Count_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items in this folder only — subfolders are counted separately. Select a folder to include its subfolders.`)
};

const es_zotero_browser_folder_item_count_hint = /** @type {(inputs: Zotero_Browser_Folder_Item_Count_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo los elementos de esta carpeta; las subcarpetas se cuentan por separado. Selecciona una carpeta para incluir sus subcarpetas.`)
};

/**
* | output |
* | --- |
* | "Items in this folder only — subfolders are counted separately. Select a folder to include its subfolders." |
*
* @param {Zotero_Browser_Folder_Item_Count_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_folder_item_count_hint = /** @type {((inputs?: Zotero_Browser_Folder_Item_Count_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_Folder_Item_Count_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_folder_item_count_hint(inputs)
	return en_zotero_browser_folder_item_count_hint(inputs)
});